/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
const DateTimeDisplay = ({ value, type, isDanger, isDarkMode }) => {
  return (
    <div
      className={isDanger ? 'countdown danger' : 'countdown'}
      css={css`
        color: ${isDarkMode ? '#fff' : '#000'};
      `}
    >
      <p>{value}</p>
      <span>{type}</span>
    </div>
  )
}

export default DateTimeDisplay
